import { render } from "./itemSlider.vue?vue&type=template&id=233636af&scoped=true"
import script from "./itemSlider.vue?vue&type=script&lang=js"
export * from "./itemSlider.vue?vue&type=script&lang=js"

import "./itemSlider.vue?vue&type=style&index=0&id=233636af&scoped=true&lang=css"

import exportComponent from "C:\\paginascedis\\general\\cedispage2.0_general_cecra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233636af"]])

export default __exports__